import Vue from "vue";
import { Component } from "vue-property-decorator";
import { WaitKeys } from "@/helpers/WaitKeys";

@Component({
    name: "layout",
})

export default class Layout extends Vue {
    public get isAuthenticated(): boolean {
        return this.$store.getters["account/isAuthenticated"];
    }

    public get isActive(): boolean {
        return this.$store.getters["account/user"]?.isActive;
    }

    public async created(): Promise<void> {
        this.$wait.start(WaitKeys.baseData);
        // TODO: Fetch user permission & application's base data here
        if (!this.isActive)
        {
            this.$router.replace({ name: "unauthorized" });
        }

        this.$wait.end(WaitKeys.baseData);
    }

    onSuccessNotification(messages: string | string[]): void {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }

        messages.forEach(message => {
            this.$notify({ type: "success", duration: 8000, text: message });
        });
    }

    onErrorNotification(messages: string | string[]): void {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }

        messages.forEach(message => {
            this.$notify({ type: "error", duration: 8000, text: message });
        });
    }
}
